// @author ben@rwd.click
// v1.0.2
$.fn.rwdSlider = function (options) {
  if ($(this).length) {
    $(this).each(function () {
      $(this).wrap('<div class="box b16 sl-wrap"></div>');
      var settings = $.extend({
        slides: 1,
        speed: 400,
        auto: false,
        pause: 5000,
        pager: false,
        controls: true
      }, options);

      if ($(document).width() < 768) {
        settings.slides = 1;
      } else if ($(document).width() == 768 && settings.slides > 2) {
        settings.slides = 2;
      }

      var slider = $(this),
        wrap = $(this).parents('.sl-wrap'),
        ul = $(this).find('>ul'),
        li = ul.find('>li'),
        ulw = (slider.outerWidth() * li.length) / settings.slides,
        liw = (ulw / li.length),
        anim = false;
      ul.width(ulw);
      slider.after('<div class="end"></div>');
      slider.css({
        overflow: 'hidden'
      });
      ul.css({
        transform: 'translateX(0)',
        position: 'relative',
        left: 0,
        transition: 'all ' + settings.speed + 'ms'
      });
      li.outerWidth(liw);
      li.css({
        display: 'block',
        float: 'left'
      });

      if (settings.controls) {
        wrap.append('<div class="controls"><i class="l"></i><i class="r"></i></div>');
        wrap.find('.controls i').click(function () {
          slide($(this).attr('class'));
        });
      }

      function slide(direction) {
        var cur = ul.css('transform').split(/[()]/)[1],
          pos = parseInt(cur.split(',')[4]),
          num = settings.slides,
          amt = (direction == 'r') ? pos - li.outerWidth() : pos + li.outerWidth(),
          mov = Math.floor(li.outerWidth() * num),
          max = (ul.outerWidth() - mov) - num;
        if (direction == 'r' && pos > -max && anim == false || direction == 'l' && pos < 0 && anim == false) {
          // Add anim flag to stop any swiping or whatnot while animation in progress
          anim = true;
          // Stop Auto functionality if a control or swipe happens
          clearInterval(wrap.data('timer'));
          // Timeout function to clear anim after slide is done
          setTimeout(function(){
            anim = false;
          }, settings.speed);
          // Animate slider
          ul.animate({
            opacity: 1
          }, {
            duration: settings.speed,
            step: function (fn) {
              fn.start = 0;
              fn.end = settings.speed;
              ul.css({
                transform: 'translateX(' + amt + 'px)'
              });
              if (settings.pager) {
                var index = Math.round(1 + -pos / li.outerWidth());
                index = (direction == 'r') ? index + 1 : index - 1;
                ul.parents('.sl-wrap').find('.sl-pager i:nth-child(' + index + ')').addClass('active');
                ul.parents('.sl-wrap').find('.sl-pager i').not(':nth-child(' + index + ')').removeClass('active');
              }
            }
          });
        } else if (direction == 'r' && pos <= -max && anim == false) {
          slider.css({
            transform: 'translateX(-40px)'
          });
          setTimeout(function () {
            slider.css({
              transform: 'translateX(0)'
            });
          }, 200);
        } else if (direction == 'l' && pos >= 0 && anim == false) {
          slider.css({
            transform: 'translateX(40px)'
          });
          setTimeout(function () {
            slider.css({
              transform: 'translateX(0)'
            });
          }, 200);
        }
      }
      // Mobile swipe detection
      var el = slider;
      var xDown = null;
      var yDown = null;

      function handleTouchStart(evt) {
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
      }

      function handleTouchMove(evt) {
        if (!xDown || !yDown) {
          return;
        }
        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;
        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            slide('r');
          } else if (xDiff < 0) {
            slide('l');
          }
        }
        xDown = null;
        yDown = null;
      }

      for (var i = 0; i < el.length; i++) {
        el[i].addEventListener('touchstart', handleTouchStart, false);
        el[i].addEventListener('touchmove', handleTouchMove, false);
      }

      // Pager stuff
      if (settings.pager) {
        if (wrap.find('.sl-pager').length <= 0) {
          var _pager = $('<div class="sl-pager"></div>');
          wrap.append(_pager);
          var _dots = [];
          for (var j = 0; j < li.length; j++) {
            _dots.push('<i></i>');
          }
          wrap.find('.sl-pager').append(_dots.join(""));
          wrap.find('.sl-pager i:first-child').addClass('active');
        }
        $(document).on('click', '.sl-pager i', function () {
          var index = $(this).index(),
            amt = li.outerWidth() * index;
          ul = $(this).parents('.sl-wrap').find('div > ul');
          if (anim == false) {
            // Add anim flag to stop any swiping or whatnot while animation in progress
            anim = true;
            // Stop Auto functionality if a control or swipe happens
            clearInterval(wrap.data('timer'));
            // Timeout function to clear anim after slide is done
            setTimeout(function(){
              anim = false;
            }, settings.speed);
            // Animate slider
            ul.animate({
              opacity: 1
            }, {
              duration: settings.speed,
              step: function (fn) {
                fn.start = 0;
                fn.end = 350;
                ul.css({
                  transform: 'translateX(' + -amt + 'px)',
                  transition: 'transform ' + settings.speed + 'ms'
                });
              }
            });
            $(this).addClass('active');
            $(this).parent('div').find('i').not(this).removeClass('active');
          }
        });
      }

      // Auto functionality
      if (settings.auto) {
        function auto() {
          var cur = ul.css('transform').split(/[()]/)[1],
            pos = parseInt(cur.split(',')[4]),
            amt = pos - li.outerWidth(),
            max = ul.width() - li.outerWidth();
          if (pos > -max) {
            // Add anim flag to stop any swiping or whatnot while animation in progress
            anim = true;
            // Timeout function to clear anim after slide is done
            setTimeout(function(){
              anim = false;
            }, settings.speed);
            // Animate slider
            ul.animate({opacity: 1}, {
              duration: settings.speed,
              step: function (fn) {
                fn.start = 0;
                fn.end = settings.speed;
                ul.css({
                  transform: 'translateX(' + amt + 'px)',
                  transition: 'transform ' + settings.speed + 'ms'
                });
                if (settings.pager) {
                  var index = Math.round(1 + -pos / li.outerWidth());
                  index = index + 1;
                  wrap.find('.sl-pager i:nth-child(' + index + ')').addClass('active');
                  wrap.find('.sl-pager i').not(':nth-child(' + index + ')').removeClass('active');
                }
              }
            });
          } else if (pos <= -max) {
            // Add anim flag to stop any swiping or whatnot while animation in progress
            anim = true;
            // Timeout function to clear anim after slide is done
            setTimeout(function(){
              anim = false;
            }, settings.speed);
            ul.animate({opacity: 1}, {
              duration: settings.speed,
              step: function (fn) {
                fn.start = 0;
                fn.end = settings.speed;
                ul.css({
                  transform: 'translateX(0px)',
                  transition: 'transform ' + settings.speed + 'ms'
                });
                wrap.find('.sl-pager i:nth-child(1)').addClass('active');
                wrap.find('.sl-pager i').not(':nth-child(1)').removeClass('active');
              }
            });
          }
        }

        wrap.on({
          mouseenter: function () {
            clearInterval($(this).data('timer'));
          },
          mouseleave: function () {
            $(this).data('timer', setInterval(auto, settings.pause));
          }
        }).trigger('mouseleave');
      }
      $(window).on('resize', function() {
        if ($(document).width() < 768) {
          settings.slides = 1;
        } else if ($(document).width() == 768 && settings.slides > 2) {
          settings.slides = 2;
        }
        ulw = (slider.outerWidth() * li.length) / settings.slides;
        liw = ulw / li.length;
        ul.width(ulw);
        li.outerWidth(liw);
        ul.css({
          transform: 'translateX(0)'
        });
        if (settings.pager) {
          $('.sl-pager i').not(':first-child').removeClass('active');
          $('.sl-pager i:first-child').addClass('active');
        }
      });
    });
  }
};